import {cookieStore} from 'libs/storage/storage';

import {HTO_COOKIE_FOR_LANDING_PAGE} from 'constants/cookie';
import {LANDING_PAGE_NAMES, LANDING_PAGES} from '../../roxCustomSetup';

const LANDING_PAGES_BY_NAME = {
    product: LANDING_PAGE_NAMES[LANDING_PAGES.product],
    category: LANDING_PAGE_NAMES[LANDING_PAGES.category],
    checkout: LANDING_PAGE_NAMES[LANDING_PAGES.checkout],
    cart: LANDING_PAGE_NAMES[LANDING_PAGES.cart],
    home: LANDING_PAGE_NAMES[LANDING_PAGES.home],
    other: LANDING_PAGE_NAMES[LANDING_PAGES.other],
};

/**
 *  setHtoLandingPageCookie set HTO_COOKIE_FOR_LANDING_PAGE cookie
 *  @param {string} val page value
 */
export const setHtoLandingPageCookie = (val: string) => {
    cookieStore.set(HTO_COOKIE_FOR_LANDING_PAGE, val);
};

/**
 * getLandingUrl function which return current HTO_COOKIE_FOR_LANDING_PAGE cookie and optional set it
 * @param {string} pathname window.location.pathname
 * @param {string | undefined} routerInfoPage dehydrated state.routerInfo.page
 * @return {string} cookie value
 */
// eslint-disable-next-line max-statements
const getLandingPage = (routerInfoPage: string | undefined): string => {
    const htoLandingPageCookie = cookieStore.get(HTO_COOKIE_FOR_LANDING_PAGE);
    if (htoLandingPageCookie) {
        return htoLandingPageCookie;
    }

    const pageName = routerInfoPage ? LANDING_PAGES_BY_NAME[routerInfoPage] : htoLandingPageCookie;
    if (!pageName) {
        return htoLandingPageCookie || '';
    }

    setHtoLandingPageCookie(pageName);
    return pageName;
};

export default getLandingPage;
